module.exports = __webpack_public_path__ + "img/3k.feb05e66.png";